export type ModuleActionCode =
  'LIST' | 'VIEW' | 'CREATE' | 'EDIT' | 'DELETE' | 'APPROVE' | 'EXPORT';

export interface ModuleActionCatalogItem {
  readonly code: ModuleActionCode;
  readonly label: string;
  readonly icon: string;
  readonly description: string;
}

export const MODULE_ACTIONS_CATALOG: readonly ModuleActionCatalogItem[] = [
  {
    code: 'LIST',
    label: 'Listar',
    icon: '',
    description: 'Listar registros, filtrar tabelas e pesquisar filas do módulo',
  },
  {
    code: 'VIEW',
    label: 'Visualizar',
    icon: '',
    description: 'Visualizar detalhes completos, dossiês 360°, timelines e anexos',
  },
  {
    code: 'CREATE',
    label: 'Criar',
    icon: '',
    description: 'Criar e cadastrar novos itens, pedidos, estudos ou lançamentos',
  },
  {
    code: 'EDIT',
    label: 'Editar',
    icon: '',
    description: 'Editar dados, alterar cláusulas/valores e atualizar etapas',
  },
  {
    code: 'DELETE',
    label: 'Deletar',
    icon: '',
    description: 'Deletar, excluir ou inativar registros com trilha de auditoria',
  },
  {
    code: 'APPROVE',
    label: 'Aprovar',
    icon: '',
    description: 'Aprovar cotações (SoD), liberar pagamentos (3-Way Match) e emitir NFS-e',
  },
  {
    code: 'EXPORT',
    label: 'Exportar',
    icon: '',
    description: 'Exportar e baixar Certificados RBC, NF-e/NFS-e, PDF, XML e ZIP',
  },
];

export interface PortalModuleCatalogEntry {
  readonly moduleId: string;
  readonly title: string;
  readonly code: string;
}

export const PORTAL_MODULES_FOR_ACCESS_MATRIX: readonly PortalModuleCatalogEntry[] = [
  {
    moduleId: 'CONTRATOS_ORCAMENTOS',
    code: 'MOD-01',
    title: 'Contratos & Orçamentos 360º',
  },
  {
    moduleId: 'CONTABILIDADE_ACUMULADOR',
    code: 'MOD-02',
    title: 'Contabilidade, Acumulador & Notas Fiscais (NF-e / NFS-e)',
  },
  {
    moduleId: 'CAIXA_COMPARTILHADA',
    code: 'MOD-03',
    title: 'Caixa Compartilhada & Barramento Multi-Módulo',
  },
  {
    moduleId: 'RECURSOS_CALIBRACAO',
    code: 'MOD-04',
    title: 'Recursos, Ciclo de Vida & Calibração RBC',
  },
  {
    moduleId: 'FORNECEDORES_COMPRAS',
    code: 'MOD-05',
    title: 'Fornecedores 360°, Compras (3-Bids) & Coletas',
  },
  {
    moduleId: 'FEASIBILITY_RECRUTAMENTO',
    code: 'MOD-06',
    title: 'Viabilidade & Recrutamento Clínico',
  },
  {
    moduleId: 'QUALIDADE_REGULATORIO',
    code: 'MOD-07',
    title: 'Qualidade (POPs) & Regulatório ANVISA/CONEP',
  },
  {
    moduleId: 'GESTAO_PESSOAS',
    code: 'MOD-08',
    title: 'Gestão de Pessoas — Pesquisadores Principais (PIs) & Coordenadoras',
  },
  {
    moduleId: 'CONFIGURACOES_AUTORIZACAO',
    code: 'MOD-09',
    title: 'Configurações do Sistema, Tabelas Clínicas & Controle de Autorização (RBAC/SoD)',
  },
  {
    moduleId: 'CONTROLE_AGENDA',
    code: 'MOD-10',
    title: 'Controle de Agenda, Calendário Mensal Dia a Dia & Salas',
  },
];
